module.exports = __webpack_public_path__ + "static/media/miband.970f5299.jpg";